

export default {
    SET_KATEGORI_SOS_LIST(state, payload) {
        state.kategoriSOSList = payload
    },
    SET_SUB_KATEGORI_SOS_LIST(state, payload) {
        state.subKategoriSOSList = payload
    },
    SET_SYARAT_LIST(state, payload) {
        state.syaratList = payload
    },
    SET_SYARAT_KUMPULS(state, payload) {
        state.syaratKumpuls = payload
    },
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
    SET_KAT_TOTAL(state, payload){
        state.totalKatRecords = payload
    },
    SET_SUB_KAT_TOTAL(state, payload){
        state.totalSubKatRecords = payload
    },
    SET_SYARAT_TOTAL(state, payload){
        state.totalSyaratRecords = payload
    }
}
